import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { BackupAzureModel } from '../types';

import { buildUrl } from './backupSettings.service';
import { queryKeys } from './queryKeys';

export function useUpdateBackupAzureSettingsMutation() {
  const queryClient = useQueryClient();

  return useMutation(updateBackupAzureSettings, {
    onSuccess: () =>
      queryClient.invalidateQueries(queryKeys.backupAzureSettings()),
    ...withError('Unable to save Azure Blob backup settings'),
  });
}

async function updateBackupAzureSettings(payload: BackupAzureModel) {
  try {
    const { data } = await axios.post(buildUrl('azure', 'settings'), payload);

    return data;
  } catch (e) {
    throw parseAxiosError(
      e as Error,
      'Unable to save Azure Blob backup settings'
    );
  }
}
